import { apiClient } from '../utils/api-client';

export type ClimbType = 'boulder' | 'route' | null;

/** One sentence of what reached this member's notifications this week. */
export type PushTeaserEntry =
  | { kind: 'place_climbs'; count: number; location_name: string; climb_type: ClimbType }
  | { kind: 'followed_climbs'; count: number; user_name: string; climb_type: ClimbType }
  | { kind: 'announcements'; count: number; location_name: string }
  | { kind: 'first_tops' | 'comments' | 'followers'; count: number };

export interface PushTeaser {
  missed: PushTeaserEntry[];
  followed: {
    location_name: string | null;
    location_type: 'Gym' | 'Crag' | null;
    user_name: string | null;
  } | null;
}

// Once per account per visit: the card is on three pages, and a week of
// notifications does not change while somebody moves between them.
const cache = new Map<string, Promise<PushTeaser>>();

class PushTeaserService {
  /** What the "turn push on" card says to this member (GET /api/push_teaser). */
  get(userId: string): Promise<PushTeaser> {
    let pending = cache.get(userId);
    if (!pending) {
      pending = apiClient.get('/api/push_teaser', { requireAuth: true }).then((response) => {
        if (!response.ok) throw new Error('Failed to load push teaser');
        return response.json() as Promise<PushTeaser>;
      });
      pending.catch(() => cache.delete(userId));
      cache.set(userId, pending);
    }
    return pending;
  }

  /** Test seam. */
  reset() {
    cache.clear();
  }
}

export const pushTeaserService = new PushTeaserService();
